/**
 * 每日模塊
 */
import axios from 'axios'
import { errAlert } from '@/plugin/apiErrAlert'
export default {
    namespaced: true,
    state: {
        todayList: null,
        todayStep: 0
    },
    getters: {
        todayListNum({ todayList }) {
            return todayList ? todayList.length : 0
        }
    },
    mutations: {
        setTodayList(state, list) {
            state.todayList = list
        },
        todayStep(state, val) {
            state.todayStep = val
        },
        todayListNext(state) {
            // state.wordSound.loadUrlList()
            state.todayList.push(state.todayList.shift())
            // state.wordSound.autoPlay(state.todayList[0].AudioFileName)
            state.todayStep++
        },
        todayListBack(state) {
            // state.wordSound.loadUrlList()
            state.todayList.unshift(state.todayList.pop())
            // state.wordSound.autoPlay(state.todayList[0].AudioFileName)
            state.todayStep--
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/today.js